import { render, staticRenderFns } from "./OrgMgr.vue?vue&type=template&id=384dfef0&"
import script from "./OrgMgr.vue?vue&type=script&lang=js&"
export * from "./OrgMgr.vue?vue&type=script&lang=js&"
import style0 from "./OrgMgr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports